/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AgentRun,
  AgentRun$inboundSchema,
  AgentRun$Outbound,
  AgentRun$outboundSchema,
} from "./agentrun.js";

export const AgentRunMcpApprovalObject = {
  AgentRunMcpApproval: "agent.run.mcp_approval",
} as const;
export type AgentRunMcpApprovalObject = ClosedEnum<
  typeof AgentRunMcpApprovalObject
>;

export type AgentRunMcpApproval = {
  object: AgentRunMcpApprovalObject;
  approvalRequestId: string;
  approved: boolean;
  sourceRunId: string;
  continuationRun: AgentRun;
};

/** @internal */
export const AgentRunMcpApprovalObject$inboundSchema: z.ZodNativeEnum<
  typeof AgentRunMcpApprovalObject
> = z.nativeEnum(AgentRunMcpApprovalObject);
/** @internal */
export const AgentRunMcpApprovalObject$outboundSchema: z.ZodNativeEnum<
  typeof AgentRunMcpApprovalObject
> = AgentRunMcpApprovalObject$inboundSchema;

/** @internal */
export const AgentRunMcpApproval$inboundSchema: z.ZodType<
  AgentRunMcpApproval,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: AgentRunMcpApprovalObject$inboundSchema,
  approval_request_id: z.string(),
  approved: z.boolean(),
  source_run_id: z.string(),
  continuation_run: AgentRun$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "approval_request_id": "approvalRequestId",
    "source_run_id": "sourceRunId",
    "continuation_run": "continuationRun",
  });
});
/** @internal */
export type AgentRunMcpApproval$Outbound = {
  object: string;
  approval_request_id: string;
  approved: boolean;
  source_run_id: string;
  continuation_run: AgentRun$Outbound;
};

/** @internal */
export const AgentRunMcpApproval$outboundSchema: z.ZodType<
  AgentRunMcpApproval$Outbound,
  z.ZodTypeDef,
  AgentRunMcpApproval
> = z.object({
  object: AgentRunMcpApprovalObject$outboundSchema,
  approvalRequestId: z.string(),
  approved: z.boolean(),
  sourceRunId: z.string(),
  continuationRun: AgentRun$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    approvalRequestId: "approval_request_id",
    sourceRunId: "source_run_id",
    continuationRun: "continuation_run",
  });
});

export function agentRunMcpApprovalToJSON(
  agentRunMcpApproval: AgentRunMcpApproval,
): string {
  return JSON.stringify(
    AgentRunMcpApproval$outboundSchema.parse(agentRunMcpApproval),
  );
}
export function agentRunMcpApprovalFromJSON(
  jsonString: string,
): SafeParseResult<AgentRunMcpApproval, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentRunMcpApproval$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentRunMcpApproval' from JSON`,
  );
}
